import {getI18n} from '../i18n';
import {GlobalSelector} from '../store/global/GlobalSelector';
import {useAppSelector} from './store/useAppSelector';
import {useMemo} from 'react';

export const useI18n = () => {
  const preferredLanguage = useAppSelector(GlobalSelector.getPreferredLanguage);

  return useMemo(() => {
    return getI18n(preferredLanguage);
  }, [preferredLanguage]);
};

